import _ from 'lodash';
import React from 'react';
import MainMenu from 'src/components/containers/main-menu';
import { Card, Layout, Page, Tooltip } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import SearchControlTable from 'src/components/views/search-control/search-control-table';
import TitleHelp from 'src/components/views/common/title-help';
import SearchPersonalizationPresentBanner from 'src/components/views/advanced-search/search-personalization-present-banner';
import EnhanceAISearchBanner from 'src/components/views/advanced-search/enhace-ai-search-banner';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import testSearchIcon from 'src/assets/images/common/test-search-icon.png';

const SearchControl = props => {
  const { i18n } = props;

  return (
    <div className="BC-Page BC-Page__SearchControl">
      <MainMenu menuId="menu-search-search-control" />
      <Page
        title={
          <div className="page-title-wrapper">
            <h1 className="Polaris-Header-Title Polaris-Header-Title__TitleWithSubtitle">
              {i18n.translate('AdminHTML.SearchControl.SearchControl.title')}
            </h1>
          </div>
        }>
        <div className="sub-title">
          <TitleHelp i18n={i18n} hrefUserManual={URL.Search_Site_Search_Algorithm} />
          <Tooltip
            content={i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.tooltip')}
            preferredPosition="above">
            <p onClick={() => history.push(routes.testYourSearch.view())}>
              <img width={16} height={16} src={testSearchIcon} alt="pfs-test-search-icon" />
              {i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.title')}
            </p>
          </Tooltip>
        </div>
        <div className="layout-wrapper">
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                <SearchPersonalizationPresentBanner
                  type="horizontal"
                  page="SearchControl"
                  showWhenDismissed={<EnhanceAISearchBanner />}
                />
              </div>
            </Layout.Section>
            <Layout.Section>
              <div className="BC-Page SearchControl__Content BC-Page__Fields">
                <Card sectioned>
                  <span>{i18n.translate('AdminHTML.SearchControl.Table.description')}</span>
                  <SearchControlTable />
                </Card>
              </div>
            </Layout.Section>
          </Layout>
        </div>
      </Page>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    enableNewSearch: _.get(state.oauth, 'tenantApp.settings.instantSearch.settings.enable', false)
  };
};

export default withI18n()(connect(mapStateToProps, null)(SearchControl));
